import React from 'react';
import Button from 'react-bootstrap/Button';
import { DelegatesType } from '../../../../api/delegatesApiTypes';
import {
    convertEmptyStringToDashes,
    formatBooleanAsYesNo,
    formatDate,
} from '../../../../utils/displayUtils';

export interface DelegatesViewModalProps {
    delegate: DelegatesType;
    toggleModal: () => void;
}

const DelegatesViewModal = (props: DelegatesViewModalProps) => {
    const { delegate } = props;
    return (
        <div className="modal-content" data-testid="accountThreshold-modal-content">
            <div className="modal-header">
                <h4 className="modal-title">View Delegate</h4>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" onClick={props.toggleModal}>
                        &times;
                    </span>
                </button>
            </div>
            <div className="modal-body">
                <div className="form-group row">
                    <div className="col-sm-6 col-form-label">Active</div>
                    <div className="col-sm-6 mt-2">{formatBooleanAsYesNo(delegate.active)}</div>
                </div>
                <div className="form-group row">
                    <div className="col-sm-6 col-form-label">Person</div>
                    <div className="col-sm-6 mt-2">{delegate.personName}</div>
                </div>
                <div className="form-group row">
                    <div className="col-sm-6 col-form-label">Delegate</div>
                    <div className="col-sm-6 mt-2">
                        {delegate.proxyName ? delegate.proxyName : '--'}
                    </div>
                </div>
                <div className="form-group row">
                    <div className="col-sm-6 col-form-label">Description</div>
                    <div className="col-sm-6 mt-2">
                        {convertEmptyStringToDashes(delegate.description)}
                    </div>
                </div>
                <div className="form-group row">
                    <div className="col-sm-6 col-form-label">Start Date</div>
                    <div className="col-sm-6 mt-2">{formatDate(delegate.startDate)}</div>
                </div>
                <div className="form-group row">
                    <div className="col-sm-6 col-form-label">End Date</div>
                    <div className="col-sm-6 mt-2">{formatDate(delegate.endDate)}</div>
                </div>
            </div>

            {/* Footer */}

            <div className="modal-footer">
                <Button
                    variant="button"
                    className="btn-outline-secondary mr-auto"
                    onClick={props.toggleModal}
                >
                    Close
                </Button>
            </div>
        </div>
    );
};

export default DelegatesViewModal;
